import { buildColumn, EditableColumnConfig } from '~components/table-view';

const columnsFactory = (categories: any[] = [], fundingSources: any[] = []) => {
  const categoryOptions = categories.map((cat) => ({ value: cat.id, label: cat.name }));
  const fundingOptions = fundingSources.map((fund) => ({ value: fund.id, label: fund.name }));

  const columns: EditableColumnConfig[] = [
    {
      id: 'category_id',
      header: 'Category',
      type: 'select',
      options: categoryOptions,
      editable: true,
    },
    {
      id: 'funding_source_id',
      header: 'Funding Source',
      type: 'select',
      options: fundingOptions,
      editable: true,
    },
    {
      id: 'contrib_proportion',
      header: 'Contribution',
      type: 'number',
      style: { cell: 'cell-align-center', header: 'header-align-center' },
      editable: true,
      props: {
        min: 0,
        max: (row: any) => row.category?.max_contrib_proportion ?? 100,
      },
    },
    {
      id: 'category.max_contrib_proportion',
      header: 'Max Contribution',
      type: 'number',
      style: { cell: 'cell-align-center', header: 'header-align-center' },
      editable: false,
      accessorFn: (row) => row.category?.max_contrib_proportion,
    },
    {
      id: 'start_date',
      header: 'Start Date',
      type: 'date',
      editable: true,
    },
    {
      id: 'end_date',
      header: 'End Date',
      type: 'date',
      editable: true,
    },
  ];
  return columns.map(buildColumn);
};

export default columnsFactory;
